import React from 'react';
import {connect} from 'react-redux';
import CabinetContainer from './CabinetContainer';
import PageAuthContainer from './auth/PageAuthContainer';
import {bindActionCreators} from 'redux';
import {initializationLogin} from '@componentDP/js_react/redux/actions/login';
import LoadingProcess from './simple/loading_process';
import {cloneDeep} from 'lodash';

class AuthContainer extends React.Component {
    constructor(props) {
        super(props);
        const {initializationLogin} = this.props;
        initializationLogin();
    }
    render() {
        const {isLogin, isLoadedLogin} = this.props;
        return (
            <React.Fragment>
                {isLoadedLogin
                    ? (isLogin
                        ? <CabinetContainer />
                        : <PageAuthContainer />)
                    : null}
                <LoadingProcess />
            </React.Fragment>
        )
    };
}

function mapStateToProps(state) {
    return {
        isLogin: cloneDeep(state.isLogin),
        isLoadedLogin: cloneDeep(state.isLoadedLogin),
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        initializationLogin,
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(AuthContainer);
